import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App.tsx';
import './index.css';
import { ShopifyProvider } from './providers/ShopifyProvider';
import { store } from './store';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ShopifyProvider>
          <App />
        </ShopifyProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
